// The Main Site Object
window.Site = {

    menuButton         : document.querySelector('button.header-menu-button'),
    footer             : document.querySelector('.footer'),
    sidebarStickyItems : document.querySelectorAll('.js-scroll-item'),
    sidebarTopbar      : document.querySelector('.header-topbar').getBoundingClientRect(),
    sidebarContainer   : document.querySelector('.sidebar-inner'),
    mobileNavigationButtons : document.querySelectorAll('.header-navigation-secondary-title'),

    // Calendar Categories Items
    calendarContainer   : null,

    noticeContainer : document.querySelector('#important-notice'),


    // The components to make the categories work
    categoriesTitle            : document.querySelector('.sidebar-categories-button'),
    categoriesContainer        : document.querySelector('.sidebar-categories'),
    categoriesMainButtons      : document.querySelectorAll('.category-filters-main-button'),
    categoriesSecondaryButtons : document.querySelectorAll('.category-filter-button'),
    categoriesOpenButton       : document.querySelector('.sidebar-open-button'),
    monthContainers            : document.querySelectorAll('.cal-month'),

    // Store a global gsap timeline reference
    gsapTimeline : null,

    // Init Function
    liftoff : () => {

        Site.showMenuOnButtonClick()
        Site.showHideMobileSubmenus()
        Site.showWarningWhenNeeded()
        Site.fixSidebarOnSmallScreens()
        Site.setBodyMarginBottom()


        Site.registerScrollPlugin()

        window.addEventListener('load' , () => {
            if (typeof gsap !== 'undefined') {
                Site.stickyScrollElementsInTheSidebar()
                Site.resetScrollAnimation()
            }

        })

        Site.POPUPNEWS.init()

        // Categories Components
        if (Site.categoriesSecondaryButtons.length) {
            
            //Site.filterTheTimeline()
            Site.initCalendar()
            Site.Filters.Open.activateOnButtonClick()
            Site.Filters.Categories.activateMain()
            Site.Filters.Categories.activateSub()
            Site.Filters.Categories.showOnTitleClick()
            Site.Filters.Shared.hideEmptyMonths()
        }

        // Minor Fixes


    },

    // Set the correct margin bottom for the body
    setBodyMarginBottom : () => {

        function setMargin () {
            document.body.style.marginBottom = `${Site.footer.clientHeight}px`
        }

        window.addEventListener('load'   , () => { setMargin() });
        window.addEventListener('resize' , () => { setMargin() });

    },

    // Fix unscrollable sidebar
    fixSidebarOnSmallScreens : () => {

        // Do nothing if we don't have a sidebar
        if (!Site.sidebarContainer) return;

        // On load compare the sidebar height against the height of the screen
        window.addEventListener('load' , () => {

            if ((window.innerHeight - 70) < Site.sidebarContainer.clientHeight)
                Site.sidebarContainer.parentElement.classList.add('sidebar-compact');
        })
    },

    // Open/Close the menu on click
    toggleMenuVisibility : () => { document.body.classList.toggle('navigation-is-open')},


    // Show/Hide the menu when the button in the header is pressed
    showMenuOnButtonClick : () => {
        if (!Site.menuButton) return;
        Site.menuButton.addEventListener('click' , Site.toggleMenuVisibility)
    },


    // Register GSAP plugin when needed
    registerScrollPlugin : () => {

        // Do nothing if we don't have items in the sidebar
        if (!Site.sidebarStickyItems.length) return;

        if (typeof gsap !== 'undefined') {
            gsap.registerPlugin(ScrollTrigger); // Register the GSAP Scroll Plugin
            Site.gsapTimeline = gsap.timeline();
        }

    },

    // Sticky scroll items inside the sidebar
    stickyScrollElementsInTheSidebar : () => {

        // Do nothing if we don't have items in the sidebar
        if (!Site.sidebarStickyItems.length) return;

        // Grab the info from the first item
        let totalHeights = 0;
        let scrollDistance = Site.sidebarStickyItems[0].offsetTop * -1;

        // Now that we know we have items we can start messing with the content
        Site.sidebarStickyItems.forEach(stickyitem => {

            // We need to store some data on the item itself
            let itemBoundingRect = stickyitem.getBoundingClientRect();
            let initialPosition  = window.innerHeight - (window.innerHeight - itemBoundingRect.top)
            let finalPosition    = Site.sidebarTopbar.bottom + totalHeights
                totalHeights     =  Math.abs(totalHeights + stickyitem.clientHeight);

            // We store the start and end points in the data attributes
            stickyitem.setAttribute('data-start'     , initialPosition);
            stickyitem.setAttribute('data-transform' , scrollDistance);
            stickyitem.setAttribute('data-end'       , finalPosition);
        })

        // Now that we're done adding values we can create the animations
        Site.sidebarStickyItems.forEach(stickyitem => {

            // We need to register a scroll animation for each items in the sidebar
            Site.gsapTimeline.to(stickyitem, {

                // This is the distance we need to scroll
                y    : stickyitem.dataset.transform,
                ease : "none",
                scrollTrigger : {

                    // The two reference items 
                    trigger : document.querySelector(stickyitem.getAttribute('href')), 
                    start   : `top ${stickyitem.dataset.start}px`,
                    end     : `top ${stickyitem.dataset.end}px`,
                    markers : false, // Turn on the markers
                    scrub   : true,
                },
            });
        })




    },

    // Reset and retrigger the sticky scroll when resizes
    resetScrollAnimation : () => {

        window.addEventListener('resize' , () => {

            // Delete all the scroll triggers
            gsap.globalTimeline.clear(); 
            ScrollTrigger.killAll();
            Site.stickyScrollElementsInTheSidebar()
        
            // recall the function
            


        })

    },


    // We need to store some data for the calendar
    Calendar : {

        selectedDates : null,

        getActiveDates : () => {

            let activeEntries = document.querySelectorAll('.js-entry:not(.js-filtered)')
            let activeDates   = [];

            activeEntries.forEach(activeEntry => {
                activeDates.push(activeEntry.dataset.date)
            })
            
            // Store the selected dates
            Site.Calendar.selectedDates = activeDates;

        },

        updateTheCalendar : () => {
            
            // Grab the active dates
            Site.Calendar.getActiveDates()

            Site.calendarContainer.update({
                onRenderCell({date, cellType,datepicker}) {

                    // We only do something if we're working on a day cell
                    if (cellType === 'day') {

                        let cellDate = datepicker.formatDate(date, 'yyyy-MM-dd');

                        // If the current day is inside the array of dates we have passed to the function add extra markup
                        if (Site.Calendar.selectedDates.includes(cellDate)) {
                            return {
                                disabled : false,
                                classes  : 'day-with-event'
                            }
                        } else {
                            return {
                                disabled : false
                            }
                        }
                    }
                },
            });
        }

    },

    // Create and populate the calendar when needed
    initCalendar : () => {

        // Grab the active dates
        Site.Calendar.getActiveDates()

        // We need two language object in order to initiate the calendar in the correct language
        const localeObjEn = {
            days        : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            daysShort   : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            daysMin     : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            months      : ['January','February','March','April','May','June', 'July','August','September','October','November','December'],
            monthsShort : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            today       : 'Today',
            clear       : 'Clear',
            dateFormat  : 'mm/dd/yyyy',
            timeFormat  : 'hh:ii aa',
            firstDay    : 1
        };

        const localeObjIt = {
            days        : ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
            daysShort   : ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
            daysMin     : ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
            months      : ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
            monthsShort : ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
            today       : 'Oggi',
            clear       : 'Cancella',
            dateFormat  : 'dd/MM/yyyy',
            timeFormat  : 'HH:mm',
            firstDay    : 1
        };

        // Time to create a new calendar object
        Site.calendarContainer = new AirDatepicker('#calendar', {

            // Pass the correct locale object base on the lang on the <html> tag
            locale: (document.documentElement.lang == 'it') ? localeObjIt : localeObjEn,
            
            // Set some options
            navTitles: {
                days: 'MMMM yyyy'
            },

            minDate : document.querySelector('.cal-month:first-child .js-entry:first-child').dataset.date,
            maxDate : document.querySelector('.cal-month:last-child .js-entry:last-child').dataset.date,

            disableNavWhenOutOfRange : true,
            minView                  : "days",
            prevHtml                 : '<svg class="arrow-left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="m11.745611 14-3.82931-3.608761L7.5 9.998914l.416414-.392207L11.745724 6l.754163.784638-3.412083 3.215501L12.5 13.215575z"/></svg>',
            nextHtml                 : '<svg class="arrow-right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M8.254389 6 12.5 10.001086 8.254276 14 7.5 13.214498l3.412196-3.214637L7.5 6.784425z"/></svg>',

            // On render we need to perform some actions
            onRenderCell({date, cellType,datepicker}) {

                // We only do something if we're working on a day cell
                if (cellType === 'day') {

                    let cellDate = datepicker.formatDate(date, 'yyyy-MM-dd');

                    // If the current day is inside the array of dates we have passed to the function add extra markup
                    if (Site.Calendar.selectedDates.includes(cellDate)) {
                        return {
                            disabled : false,
                            classes  : 'day-with-event'
                        }
                    } else {
                        return {
                            disabled : false
                        }
                    }
                }
            },

            // Select cell event
            onSelect({date, formattedDate, datepicker}) {

                // Properly format the date
                let searchDate = datepicker.formatDate(date, 'yyyy-MM-dd');


                // Search for the first item with this date
                let relatedItem = document.querySelector(`.js-entry[data-date="${searchDate}"]:not(.js-filtered)`)

                if (relatedItem) {
                    relatedItem.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" })
                    relatedItem.firstElementChild.open = true
                }


            }
        })

    },

    // We need to better structure the filters
    Filters : {


        // Actions related to the OPEN filters
        Open : {

            // The two main collections for OPEN and non-OPEN
            button        : document.querySelector('.sidebar-open-button'),
            openEvents    : document.querySelectorAll('.js-entry-open'),
            nonOpenEvents : document.querySelectorAll(`.js-entry:not(.js-entry-open)`),

            // Show only the events that are OPEN
            toggleEntries : () => {
                
                // Hide all the non open events
                Site.Filters.Open.nonOpenEvents.forEach(entry => {
                    entry.classList.toggle('js-filtered-by-open')

                    if (!entry.classList.contains('js-filtered-by-category'))
                        entry.classList.toggle('js-filtered')
                })

            },

            activateOnButtonClick : () => {

                if (!Site.Filters.Open.button) return;

                Site.Filters.Open.button.addEventListener('click' , () => {

                    // Toggle the active state
                    Site.categoriesOpenButton.toggleAttribute('aria-selected')

                    // Filter the events
                    Site.Filters.Open.toggleEntries()
                    Site.Filters.Shared.hideEmptyMonths()

                    Site.Calendar.updateTheCalendar()

                })
            }

        },

        // Actions related to the Categories
        Categories: {

            // The components
            mainButtons      : document.querySelectorAll('.category-filters-main-button'),
            secondaryButtons : document.querySelectorAll('.category-filter-button'),

            // Activate each category section on click
            activateMain : () => {

                // Loop through the main buttons
                Site.Filters.Categories.mainButtons.forEach(categoryMainButton => {

                    // Attach events to the main buttons
                    categoryMainButton.addEventListener('click' , () => {

                        // Toggle the aria attribute on click
                        categoryMainButton.toggleAttribute('aria-selected');

                        // Also toggle the attributes on all the siblings
                        categoryMainButton.nextElementSibling.querySelectorAll('button').forEach(button => {
                            button.toggleAttribute('aria-disabled');
                            button.removeAttribute('aria-selected');

                        })

                        // Filter the items
                        Site.Filters.Categories.toggleEntries(categoryMainButton , `.main-${categoryMainButton.value}` , 'main');

                    })

                })
            },

            // Activate each category button on click
            activateSub : () => {

                // Loop through all the buttons
                Site.Filters.Categories.secondaryButtons.forEach(categorySubButton => {
                    
                    // Add events on the buttons
                    categorySubButton.addEventListener('click' , () => {

                        // Do nothing if the button is disabled
                        if (categorySubButton.hasAttribute('aria-disabled')) return;

                        // Toggle the aria attribute on click
                        categorySubButton.toggleAttribute('aria-selected');

                        // Filter the items
                        Site.Filters.Categories.toggleEntries(categorySubButton , `.sub-${categorySubButton.value}` , 'sub')

                    })
                })
            },

            // Show hide the items based on the passed value
            toggleEntries : (filterButton , filterValue , filterType) => {

                // If we have clicked on a main category we can bulk hide a lot of things
                if (filterType == 'main') {

                    // Grab all the items in this category
                    let entries = document.querySelectorAll(filterValue);

                    // if the button was already selected we need to turn things off
                    if (filterButton.hasAttribute('aria-selected')) {
                        entries.forEach(entry => { entry.classList.remove('js-filtered' , 'js-filtered-by-category') });
                    } else {
                        entries.forEach(entry => { entry.classList.add('js-filtered' , 'js-filtered-by-category') });
                    }
                }

                // If we have clicked on a sub category we need to filter out the entries
                if (filterType == 'sub') {

                    // Grab all the active filters in this section
                    let activeFilters = filterButton.parentElement.querySelectorAll('button[aria-selected]');

                    // All filters are turned off and that means we need to display all items
                    if (activeFilters.length == 0) {

                        // Show/Hide all the items in the calendar based on the value of the clicked buttons
                        document.querySelectorAll(`.main-${filterButton.dataset.category}`).forEach(entry => {

                            // Skip if this was already hidden by the open
                            if (entry.classList.contains('js-filtered-by-open')) return;

                            // Remove the classes by all the remaining items 
                            entry.classList.remove('js-filtered' , 'js-filtered-by-category')
                        })

                    }

                    // If this is the first active filter then hide everything and then show the item
                    if (activeFilters.length != 0) {

                        // Hide everything
                        document.querySelectorAll(`.main-${filterButton.dataset.category}`).forEach(entry => {
                            entry.classList.add('js-filtered' , 'js-filtered-by-category')
                        })

                        activeFilters.forEach(activeFilter => {
                            document.querySelectorAll(`.sub-${activeFilter.value}`).forEach(entry => {

                                // Skip if this was already hidden by the open
                                if (entry.classList.contains('js-filtered-by-open')) return;

                                entry.classList.remove('js-filtered' , 'js-filtered-by-category')
                            })
                        })

                    }

                }


                // We need to refresh the timeline
                Site.Filters.Shared.hideEmptyMonths()
                Site.Calendar.updateTheCalendar()

            },

            // On mobile show the categories when the title is clicked
            showOnTitleClick : () => {
                Site.categoriesTitle.addEventListener('click' , () => {

                    Site.categoriesContainer.classList.toggle('is-expanded')
                })
            }

        },

        // General actions
        Shared: {

            // The components
            monthContainers  : document.querySelectorAll('.cal-month'),

            // Hide the empty month containers
            hideEmptyMonths : () => {

                // Loop through all the months
                Site.Filters.Shared.monthContainers.forEach(monthContainer => {

                    // If the month has visible items we need to make sure it's visible
                    if (monthContainer.querySelectorAll('.js-entry:not(.js-filtered)').length) {
                        monthContainer.removeAttribute('aria-hidden')
                        return;
                    }
                    
                    // If not we can hide it 
                    monthContainer.setAttribute('aria-hidden' , true)

                })

            }

        }



    },



    // Show hide the submenus on click
    showHideMobileSubmenus : () => {

        if (!Site.mobileNavigationButtons) return;

        Site.mobileNavigationButtons.forEach(button => {
            button.addEventListener('click' , (event) => {

                button.parentElement.parentElement.classList.toggle('active-submenu')
                document.body.classList.toggle('mobile-submenu-is-active')

            })
        })
    },

    // Show Warning Message
    showWarningWhenNeeded : () => {

        // If we don't have the notice we can abort the operation
        if (!Site.noticeContainer) return;
        
        if (!sessionStorage.getItem("WarningShown")) {

            Site.noticeContainer.showPopover()
            sessionStorage.setItem("WarningShown" , "Warning Has Been Shown");

        }

    },


    // Popup News Functions
    POPUPNEWS : {

        button  : document.querySelector('.popup-news-button'),
        popup   : document.querySelector('#popup-news'),
        notice  : document.querySelector('.header-topbar-news-notice'),
        project : document.querySelector('.progetto-banner-inner-wrapper'),

        init : () => {
            if (!Site.POPUPNEWS.button) return;
            Site.POPUPNEWS.hideOnClick()
            Site.POPUPNEWS.showOnClick()
            Site.POPUPNEWS.showWhenNeeded()
        },

        // Show hide the popup and the indicator
        togglePopupNews : () => {
            document.body.classList.toggle('popup-news-is-visible')
            Site.POPUPNEWS.popup.classList.toggle('is-hidden')
            Site.POPUPNEWS.notice.classList.toggle('is-hidden')
            Site.POPUPNEWS.adjustProjectBannerPadding()
        },

        hideOnClick : () => {
            Site.POPUPNEWS.button.addEventListener('click' , () => { Site.POPUPNEWS.togglePopupNews() })
        },

        showOnClick : () => {
            Site.POPUPNEWS.notice.addEventListener('click' , () => { Site.POPUPNEWS.togglePopupNews() })
        },

        showWhenNeeded : () => {

            // Check if the current news needs to be shown
            let uuid = Site.POPUPNEWS.popup.dataset.uuid;

            if (document.documentElement.id == "home" && !sessionStorage.getItem(uuid)) {
                Site.POPUPNEWS.popup.classList.remove('is-hidden')
                document.body.classList.toggle('popup-news-is-visible')
                Site.POPUPNEWS.adjustProjectBannerPadding()
            } else {
                Site.POPUPNEWS.notice.classList.remove('is-hidden')
            }

            // Save the UUID in session and don't show the news again on the home
            sessionStorage.setItem(uuid , 'News has been displayed')

        },

        // Adjust the porject banner when a news is open
        adjustProjectBannerPadding : () => {

            // Do nothing if there's no popup
            if (!Site.POPUPNEWS.project) return;

            // Get the distance to the 
            if (document.body.classList.contains('popup-news-is-visible')) {
                Site.POPUPNEWS.project.style.setProperty("--margin-top" , `${document.querySelector('.popup-news-inner').clientHeight}px`)
            } else {
                Site.POPUPNEWS.project.removeAttribute('style')
            }

        }

    }

}

// Launch The Script
Site.liftoff()